import { Injectable } from '@angular/core';
import { Preferencia } from '../interfaces/preferencia';

@Injectable({
  providedIn: 'root'
})
export class PreferenciasWebService {

  constructor() { }

  getAll(): Preferencia {
    const preferencias = localStorage.getItem('preferences') || '{}';

    return JSON.parse(preferencias);
  }

  getPreference(key: string) {
    const preferencias = this.getAll();

    return preferencias[key];
  }

  setPreference(key: string, valor: any) {
    let preferencias = this.getAll();

    preferencias[key] = valor;

    this.save(preferencias);
  }

  private save(preferencias: Preferencia) {
    localStorage.setItem('preferences', JSON.stringify(preferencias));
  }

  clear() {
    localStorage.removeItem('preferences');
  }
}
